import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { Container } from "@/screens/rewards/components/Container"
import BFText, { Body, H5, Small, Tiny } from "@/components/standard/BFText"
import Svg, { Defs, G, LinearGradient, Path, Stop } from "react-native-svg"
import { AccordionHeader } from "@/screens/loans/components/setup/AccordionHeader"
import {
  AccordionContent,
  AccordionItem,
} from "@/components/reusables/ui/accordion"
import { useState } from "react"
import { PropertyInfoSummary } from "@/screens/loans/components/setup/PropertyInfoSummary"
import { formatNumber } from "react-native-currency-input"
import { useLoanContext } from "@/screens/loans/components/LoanContext"
import { NegativeROIWarning } from "@/screens/loans/components/NegativeROIWarning"
import WarningCircle from "phosphor-react-native/src/icons/WarningCircle"

function HangTightClipart() {
  return (
    <Svg width={169} height={132} viewBox="0 0 169 132" fill="none">
      <G>
        <Path
          d="M168.928 61.666l-29.57 50.193-72.196-27.906 29.57-50.193 72.196 27.906z"
          fill="#fff"
        />
        <Path
          d="M139.358 111.932a.08.08 0 01-.026-.005L67.136 84.021a.072.072 0 01-.036-.105l29.57-50.193a.072.072 0 01.088-.03l72.196 27.905a.072.072 0 01.041.094l-.005.01-29.57 50.194a.072.072 0 01-.062.036zm-72.09-28.016l72.059 27.854 29.495-50.067L96.763 33.85 67.268 83.916z"
          fill="#121F3A"
        />
        <Path
          d="M112.564 66.741l-17.072-6.598-11.096 18.833 17.073 6.599 11.095-18.834z"
          fill="#fff"
        />
        <Path
          d="M101.469 85.647a.08.08 0 01-.026-.004l-17.072-6.6a.072.072 0 01-.036-.104L95.43 60.106a.072.072 0 01.088-.03l17.072 6.598a.073.073 0 01.042.093c-.002.004-.003.008-.006.011l-11.095 18.834a.072.072 0 01-.062.035zM84.502 78.94l16.936 6.547 11.021-18.708-16.936-6.546-11.02 18.707z"
          fill="#121F3A"
        />
        <Path
          d="M112.564 66.741l.415-.704-1.456.301 1.041.403z"
          fill="#75FAD4"
        />
        <Path
          d="M112.564 66.813a.07.07 0 01-.025-.005l-1.041-.402a.072.072 0 01-.042-.094.072.072 0 01.053-.044l1.455-.302a.073.073 0 01.086.056.076.076 0 01-.009.052l-.414.704a.075.075 0 01-.063.035zm-.785-.454l.754.292.301-.51-1.055.218z"
          fill="#121F3A"
        />
        <Path
          d="M134.584 60.03l-32.223-12.456-8.09 12.094 14.673 5.672 25.64-5.31z"
          fill="#75FAD4"
        />
        <Path
          d="M108.944 65.413a.075.075 0 01-.026-.005l-14.672-5.671a.072.072 0 01-.035-.108l8.09-12.095a.071.071 0 01.086-.027l32.224 12.456a.072.072 0 01.041.093.073.073 0 01-.052.045l-25.64 5.31a.064.064 0 01-.015.002h-.001zm-14.562-5.778l14.568 5.63 25.379-5.255-31.941-12.346-8.007 11.97z"
          fill="#121F3A"
        />
        <Path
          d="M149.729 65.884l-15.145-5.855 9.519 16.82 5.626-10.965z"
          fill="#75FAD4"
        />
        <Path
          d="M144.103 76.922a.072.072 0 01-.063-.036l-9.519-16.82a.072.072 0 01.089-.102l15.145 5.855a.072.072 0 01.042.093l-.003.007-5.627 10.965a.072.072 0 01-.062.039h-.002zm-9.356-16.75l9.353 16.525 5.528-10.773-14.882-5.753h.001z"
          fill="#121F3A"
        />
        <Path
          d="M133.555 61.775l-20.574 4.262-.415.703-11.095 18.834 29.424 11.374 11.095-18.834.416-.706-8.851-15.632z"
          fill="#fff"
        />
        <Path
          d="M130.895 97.02a.08.08 0 01-.026-.004l-29.424-11.374a.073.073 0 01-.042-.094c.002-.003.003-.007.006-.01L112.919 66a.071.071 0 01.047-.034l20.575-4.261a.072.072 0 01.077.035l8.851 15.632a.072.072 0 010 .073l-11.511 19.539a.073.073 0 01-.062.035l-.001.002zm-29.319-11.482l29.288 11.32 11.458-19.45-8.804-15.55-20.492 4.244-11.45 19.436z"
          fill="#121F3A"
        />
        <Path
          d="M134.584 60.031l-25.641 5.31 2.581.998 1.455-.301 20.575-4.261h.001l9.48 16.742.176.069 2.399.927-1.508-2.664-9.519-16.82h.001z"
          fill="#286588"
        />
        <Path
          d="M145.611 79.585a.075.075 0 01-.026-.004l-2.576-.996a.08.08 0 01-.037-.032l-9.453-16.697-21.98 4.552a.068.068 0 01-.041-.003l-2.581-.998a.072.072 0 01.012-.138l25.64-5.31a.073.073 0 01.078.035l11.027 19.483a.073.073 0 01-.063.108zm-2.526-1.126l2.362.913-10.901-19.261-25.348 5.25 2.331.9 22.009-4.558a.076.076 0 01.08.035l9.467 16.72z"
          fill="#121F3A"
        />
        <Path
          d="M98.417 64.848l-9.38 15.92 7.793 3.013 9.38-15.921-7.793-3.012z"
          fill="#286588"
        />
        <Path
          d="M96.83 83.853a.074.074 0 01-.026-.004l-7.793-3.013a.072.072 0 01-.036-.104l9.38-15.921a.073.073 0 01.088-.03l7.793 3.011a.072.072 0 01.041.094l-.005.01-9.38 15.922a.072.072 0 01-.062.035zm-7.687-3.12l7.656 2.959 9.305-15.795-7.656-2.96-9.305 15.795z"
          fill="#121F3A"
        />
        <Path
          d="M105.06 68.318l-6.36-2.459-3.884 6.594 6.36 2.458 3.884-6.593z"
          fill="#75FAD4"
        />
        <Path
          d="M101.177 74.984a.073.073 0 01-.026-.005l-6.36-2.459a.072.072 0 01-.037-.104l3.884-6.593a.072.072 0 01.088-.031l6.361 2.458a.072.072 0 01.036.105l-3.884 6.593a.073.073 0 01-.062.036zm-6.254-2.567l6.223 2.405 3.81-6.467-6.224-2.405-3.81 6.467z"
          fill="#121F3A"
        />
        <Path
          d="M99.903 77.072l-6.36-2.459-3.43 5.823 6.36 2.459 3.43-5.823z"
          fill="#75FAD4"
        />
        <Path
          d="M96.472 82.968a.076.076 0 01-.026-.005l-6.36-2.458a.072.072 0 01-.037-.105l3.43-5.823a.073.073 0 01.088-.03l6.36 2.458a.072.072 0 01.037.104l-3.43 5.823a.072.072 0 01-.063.036zM90.218 80.4l6.223 2.405 3.356-5.696-6.223-2.405-3.356 5.696zm4.393-7.25a.602.602 0 00-.714.24c-.137.233-.039.502.218.602.258.1.578-.009.715-.24.136-.233.039-.501-.22-.6"
          fill="#121F3A"
        />
        <Path
          d="M94.316 74.1a.633.633 0 01-.227-.041.5.5 0 01-.302-.3.481.481 0 01.047-.406.678.678 0 01.802-.27.498.498 0 01.302.299.48.48 0 01-.047.405.673.673 0 01-.575.313zm.089-.914a.522.522 0 00-.447.241.335.335 0 00-.034.285c.033.096.11.171.217.212a.529.529 0 00.626-.21.336.336 0 00.034-.284.359.359 0 00-.217-.212.494.494 0 00-.18-.033h.001z"
          fill="#121F3A"
        />
        <Path
          d="M127.7 77.189l-5.259-2.033-5.26-2.033-6.267 10.638 5.26 2.033 5.259 2.033 5.259 2.033 6.268-10.639-5.26-2.032z"
          fill="#286588"
        />
        <Path
          d="M126.693 89.933a.077.077 0 01-.026-.005l-15.779-6.099a.072.072 0 01-.036-.104l6.267-10.639a.072.072 0 01.088-.03l15.779 6.099a.072.072 0 01.042.093.03.03 0 01-.006.011l-6.267 10.638a.073.073 0 01-.062.036zm-15.673-6.208l15.642 6.046 6.193-10.512-15.642-6.046-6.193 10.512z"
          fill="#121F3A"
        />
        <Path
          d="M127.141 77.607l-4.748-1.835-5.659 9.604 4.749 1.836 5.658-9.605z"
          fill="#75FAD4"
        />
        <Path
          d="M121.483 87.284a.075.075 0 01-.026-.005l-4.748-1.835a.072.072 0 01-.042-.093l.005-.011 5.659-9.605c.018-.03.055-.044.089-.03l4.748 1.834a.072.072 0 01.041.094.053.053 0 01-.005.01l-5.658 9.606a.075.075 0 01-.063.035zm-4.643-1.945l4.612 1.783 5.584-9.479-4.612-1.782-5.584 9.478z"
          fill="#121F3A"
        />
        <Path
          d="M122.391 75.77l-4.748-1.834-5.659 9.604 4.749 1.836 5.658-9.605z"
          fill="#75FAD4"
        />
        <Path
          d="M116.733 85.448a.075.075 0 01-.026-.004l-4.748-1.836a.072.072 0 01-.037-.104l5.659-9.605a.072.072 0 01.088-.03l4.748 1.834a.072.072 0 01.042.094.03.03 0 01-.006.01l-5.658 9.606a.073.073 0 01-.062.035zm-4.643-1.944l4.612 1.782 5.584-9.479-4.612-1.782-5.584 9.479z"
          fill="#121F3A"
        />
        <Path
          d="M131.889 79.443l-4.748-1.836-5.659 9.605 4.749 1.836 5.658-9.605z"
          fill="#75FAD4"
        />
        <Path
          d="M126.232 89.12a.069.069 0 01-.026-.005l-4.749-1.835a.072.072 0 01-.042-.094l.005-.01 5.659-9.605a.073.073 0 01.089-.031l4.748 1.835a.072.072 0 01.036.105l-5.658 9.605a.075.075 0 01-.062.035zm-4.644-1.944l4.612 1.782 5.584-9.478-4.612-1.783-5.584 9.479z"
          fill="#121F3A"
        />
        <Path
          d="M125.695 11.162c1.485.235 2.275 1.557 1.761 2.951l-40.21 109.163c-.513 1.395-2.136 2.333-3.62 2.098l-57.288-9.092c-1.484-.236-2.27-1.557-1.757-2.952L64.79 4.167c.513-1.394 2.133-2.333 3.617-2.098l57.287 9.093z"
          fill="#fff"
        />
        <Path
          d="M84.088 125.483c-.158 0-.317-.012-.473-.037l-57.287-9.092c-.747-.119-1.346-.506-1.687-1.09-.336-.574-.38-1.27-.127-1.958L64.723 4.142c.524-1.423 2.183-2.385 3.697-2.144l57.286 9.092c.748.119 1.349.507 1.691 1.092.336.574.381 1.269.127 1.957l-40.21 109.163c-.47 1.276-1.852 2.181-3.226 2.181zM67.945 2.106c-1.314 0-2.637.866-3.086 2.086l-40.21 109.163c-.238.648-.197 1.299.116 1.835.32.547.883.908 1.585 1.02l57.287 9.092c1.452.231 3.04-.689 3.543-2.051l40.209-109.163c.238-.646.196-1.297-.117-1.833-.32-.547-.884-.91-1.588-1.022L68.397 2.141c-.15-.023-.301-.035-.452-.035z"
          fill="#121F3A"
        />
        <Path
          d="M126.407 9.228c2.622.416 4.011 2.75 3.104 5.212l-40.21 109.163c-.905 2.458-3.766 4.117-6.386 3.701l-57.287-9.092c-2.622-.416-4.01-2.749-3.105-5.208L62.732 3.841c.907-2.462 3.767-4.12 6.388-3.705l57.287 9.092zm-39.16 114.049l40.21-109.163c.514-1.395-.277-2.716-1.762-2.952L68.408 2.07c-1.484-.236-3.104.703-3.618 2.098L24.581 113.33c-.514 1.395.273 2.716 1.758 2.951l57.287 9.092c1.484.236 3.108-.702 3.621-2.097z"
          fill="#75FAD4"
        />
        <Path
          d="M83.73 127.44c-.277 0-.554-.021-.827-.064l-57.287-9.093c-1.301-.206-2.346-.88-2.941-1.898-.584-.998-.662-2.208-.221-3.406L62.664 3.816c.917-2.489 3.818-4.172 6.468-3.752l57.286 9.093c1.302.206 2.346.88 2.941 1.897.584.999.662 2.21.22 3.41l-40.21 109.163c-.821 2.23-3.238 3.813-5.639 3.813zM68.302.145c-2.342 0-4.7 1.545-5.502 3.722L22.59 113.029c-.425 1.157-.351 2.323.21 3.283.573.98 1.581 1.629 2.84 1.828l57.286 9.093c2.585.41 5.414-1.23 6.308-3.655l40.209-109.163c.427-1.16.353-2.326-.209-3.287-.573-.979-1.581-1.628-2.839-1.828L69.109.208a5.078 5.078 0 00-.807-.063zm15.786 125.338c-.159 0-.317-.012-.473-.037l-57.288-9.092c-.746-.118-1.346-.505-1.688-1.09-.335-.573-.38-1.269-.126-1.958L64.723 4.143C65.246 2.72 66.904 1.758 68.418 2l57.287 9.092c.747.119 1.348.507 1.691 1.092.335.574.381 1.268.127 1.957l-40.21 109.163c-.47 1.276-1.853 2.181-3.227 2.181v-.001zM67.944 2.106c-1.313 0-2.636.867-3.086 2.087L24.65 113.356c-.239.647-.197 1.299.116 1.835.32.546.882.908 1.585 1.019l57.287 9.092c1.452.231 3.04-.689 3.542-2.05l40.209-109.163c.238-.646.197-1.297-.116-1.833-.32-.547-.884-.91-1.588-1.022L68.396 2.142c-.15-.024-.3-.036-.452-.035z"
          fill="#121F3A"
        />
        <Path
          d="M103.532 9.761c1.118.178 1.715 1.182 1.328 2.235-.386 1.047-1.618 1.764-2.736 1.587l-14.43-2.29c-1.118-.178-1.719-1.187-1.333-2.233.388-1.053 1.623-1.767 2.74-1.59l14.431 2.29v.001z"
          fill="#75FAD4"
        />
        <Path
          d="M102.471 13.682c-.121 0-.24-.009-.359-.028l-14.43-2.29c-.568-.09-1.026-.387-1.289-.836-.257-.44-.293-.97-.101-1.493.4-1.085 1.665-1.819 2.82-1.636l14.429 2.29c.568.09 1.025.386 1.286.834.257.44.293.972.099 1.498-.357.972-1.41 1.661-2.455 1.661zM88.749 7.516c-.988 0-1.983.651-2.32 1.569-.178.48-.146.966.09 1.368.24.412.661.684 1.186.767l14.43 2.29c1.088.173 2.28-.518 2.657-1.54.178-.484.147-.973-.088-1.375-.24-.41-.66-.68-1.184-.763l-14.43-2.29a2.211 2.211 0 00-.34-.027z"
          fill="#121F3A"
        />
        <Path
          d="M131.821 15.753l-2.468-4.56c.499.923.59 2.07.157 3.247L89.3 123.603c-.905 2.459-3.765 4.118-6.386 3.702l-57.287-9.092c-1.369-.218-2.401-.958-2.947-1.966l2.468 4.56c.545 1.008 1.578 1.748 2.947 1.965l57.288 9.092c2.621.416 5.481-1.243 6.386-3.701L131.978 19c.434-1.177.343-2.325-.157-3.247z"
          fill="url(#paint0_linear_5819_5190)"
        />
        <Path
          d="M86.2 132.001c-.277 0-.554-.021-.827-.065l-57.287-9.092c-1.332-.211-2.424-.941-2.999-2.002l-2.469-4.559a.073.073 0 01.03-.099.073.073 0 01.097.029c.553 1.021 1.608 1.724 2.895 1.928l57.287 9.092c2.585.41 5.414-1.229 6.308-3.655l40.209-109.163c.41-1.114.356-2.246-.153-3.187a.072.072 0 01.029-.098.072.072 0 01.098.029l2.468 4.56c.529.977.587 2.152.162 3.306l-40.21 109.163c-.82 2.23-3.238 3.813-5.638 3.813zm-62.974-14.899l1.988 3.67c.552 1.021 1.608 1.724 2.895 1.928l57.286 9.092c2.585.411 5.414-1.229 6.308-3.655l40.21-109.162c.41-1.115.356-2.247-.153-3.187l-1.985-3.666a4.194 4.194 0 01-.196 2.344L89.37 123.629c-.916 2.487-3.816 4.168-6.466 3.748l-57.286-9.093c-.954-.151-1.786-.568-2.392-1.182z"
          fill="#121F3A"
        />
        <Path
          d="M54.761 124.176l-6.093-.967c-.81-.129-1.272.132-1.029.581.243.449 1.1.919 1.911 1.048l6.094.967c.81.129 1.272-.132 1.028-.581-.243-.449-1.1-.919-1.91-1.048"
          fill="#121F3A"
        />
        <Path
          d="M56.027 125.91c-.133 0-.265-.012-.396-.033l-6.093-.967c-.83-.132-1.71-.619-1.963-1.085-.122-.225-.072-.38-.008-.47.157-.222.572-.303 1.111-.218l6.093.967c.83.132 1.71.619 1.963 1.085.122.225.072.38.008.471-.115.163-.372.25-.715.25zm-7.75-2.662c-.289 0-.504.066-.591.19-.059.083-.053.189.016.317.234.432 1.067.885 1.858 1.011l6.093.967c.476.076.848.015.97-.157.058-.083.053-.19-.016-.318-.234-.432-1.068-.885-1.859-1.011l-6.093-.967a2.532 2.532 0 00-.378-.032zm-7.23-1.076c-.622-.099-.977.101-.79.447.187.346.847.708 1.47.807.625.099.98-.102.792-.448-.187-.345-.846-.707-1.471-.806"
          fill="#121F3A"
        />
        <Path
          d="M42.029 123.522a1.95 1.95 0 01-.314-.026c-.653-.104-1.322-.475-1.522-.844-.076-.14-.077-.275-.004-.379.124-.176.45-.241.87-.174.655.104 1.324.474 1.524.843.076.141.078.277.004.38-.092.132-.29.201-.558.201v-.001zm-1.276-1.304c-.217 0-.382.049-.445.138-.041.058-.036.134.013.226.175.324.824.676 1.417.771.356.056.643.011.732-.115.04-.057.036-.134-.014-.227-.174-.323-.825-.674-1.42-.769a1.928 1.928 0 00-.283-.024zm-3.056-.579c-.622-.099-.977.101-.79.446.188.347.847.709 1.47.808.625.099.98-.102.792-.448-.187-.345-.846-.707-1.472-.806"
          fill="#121F3A"
        />
        <Path
          d="M38.678 122.991a2.073 2.073 0 01-.314-.027c-.653-.103-1.321-.474-1.521-.844-.076-.14-.078-.274-.005-.378.125-.176.45-.241.87-.174.655.104 1.325.474 1.524.843.077.141.078.276.005.38-.093.132-.29.201-.559.201v-.001zm-1.277-1.305c-.217 0-.381.049-.444.139-.041.058-.037.134.013.225.175.324.824.677 1.417.771.355.056.642.011.732-.114.04-.058.036-.135-.014-.228-.174-.322-.825-.674-1.42-.769a1.927 1.927 0 00-.284-.024zm-3.055-.579c-.625-.099-.977.102-.79.447.188.347.843.708 1.469.807.626.1.98-.101.792-.448-.186-.344-.846-.706-1.47-.805"
          fill="#121F3A"
        />
        <Path
          d="M35.327 122.46a2.072 2.072 0 01-.314-.027c-.653-.103-1.321-.474-1.521-.844-.076-.14-.078-.276-.005-.379.125-.178.442-.241.87-.174.655.104 1.325.474 1.523.843.077.141.079.277.005.38-.093.132-.29.201-.558.201zm-1.278-1.304c-.217 0-.38.048-.443.138-.041.057-.036.134.014.226.177.329.813.674 1.417.77.355.057.642.012.731-.114.041-.058.037-.134-.014-.227-.174-.323-.824-.674-1.418-.769a1.71 1.71 0 00-.286-.024zm35.236 5.497c-.626-.099-.981.102-.794.447.188.346.847.708 1.472.807.626.1.977-.102.79-.448-.188-.345-.843-.706-1.468-.806z"
          fill="#121F3A"
        />
        <Path
          d="M70.265 128.005c-.105 0-.21-.01-.313-.026-.655-.104-1.325-.476-1.525-.845-.076-.14-.077-.275-.004-.379.126-.178.444-.242.873-.174.653.104 1.321.474 1.52.843.077.142.079.277.005.381-.092.131-.288.2-.556.2zm-1.278-1.305c-.218 0-.382.049-.446.139-.04.058-.036.133.014.225.177.329.815.674 1.42.771.354.056.64.011.728-.114.041-.058.036-.135-.014-.228-.177-.328-.812-.672-1.415-.768a1.833 1.833 0 00-.287-.025zm3.649.485c-.626-.099-.977.101-.79.446.187.347.843.708 1.469.808.626.099.98-.102.793-.448-.187-.345-.847-.707-1.472-.806"
          fill="#121F3A"
        />
        <Path
          d="M73.618 128.538a2.2 2.2 0 01-.314-.026c-.653-.104-1.321-.475-1.521-.845-.076-.14-.078-.275-.005-.379.125-.178.442-.241.87-.174.655.104 1.324.474 1.523.843.077.142.079.277.005.381-.093.131-.29.2-.558.2zm-1.278-1.305c-.217 0-.38.049-.443.138-.041.058-.036.134.014.226.177.329.813.675 1.417.771.355.057.642.011.731-.114.041-.058.037-.135-.013-.228-.175-.322-.825-.674-1.42-.768a1.817 1.817 0 00-.285-.025zm3.647.485c-.622-.099-.977.101-.79.446.187.347.847.709 1.469.808.625.099.98-.102.792-.448-.187-.345-.846-.707-1.471-.806"
          fill="#121F3A"
        />
        <Path
          d="M76.967 129.068a2.068 2.068 0 01-.314-.027c-.653-.104-1.321-.474-1.521-.844-.076-.14-.078-.274-.004-.378.124-.176.449-.241.87-.174.655.104 1.324.474 1.523.842.077.141.079.277.005.38-.093.132-.29.201-.559.201zm-1.276-1.304c-.217 0-.382.049-.445.138-.041.058-.036.134.013.226.175.323.824.676 1.417.77.356.056.643.011.732-.115.04-.057.036-.134-.014-.227-.174-.323-.825-.674-1.42-.769a1.927 1.927 0 00-.283-.024v.001zm-9.756-1.643c-.625-.099-.98.101-.793.446.188.347.846.708 1.472.808.622.099.977-.102.79-.449-.188-.344-.847-.706-1.469-.805z"
          fill="#121F3A"
        />
        <Path
          d="M66.909 127.472c-.102 0-.204-.009-.305-.025-.655-.104-1.325-.475-1.525-.845-.076-.14-.077-.274-.004-.378.126-.179.444-.242.873-.174.642.101 1.325.479 1.52.842.077.141.079.277.005.381-.092.13-.294.2-.564.2v-.001zm-1.27-1.303c-.218 0-.383.049-.446.139-.041.058-.037.133.013.225.178.329.815.674 1.42.771.354.056.64.011.729-.115.04-.058.036-.135-.014-.228-.174-.322-.823-.673-1.416-.768a1.96 1.96 0 00-.286-.024zm-3.053-.579c-.626-.099-.98.101-.794.446.188.346.847.708 1.472.808.622.099.977-.102.79-.449-.187-.345-.846-.706-1.468-.805z"
          fill="#121F3A"
        />
        <Path
          d="M63.557 126.941c-.102 0-.203-.009-.304-.026-.655-.104-1.325-.475-1.525-.844-.076-.14-.078-.275-.004-.379.126-.179.444-.242.873-.174.642.102 1.325.48 1.52.842.077.142.079.277.005.381-.091.131-.294.2-.564.2zm-1.27-1.304c-.218 0-.382.049-.446.138-.04.058-.036.134.014.226.178.329.815.674 1.42.771.354.056.64.01.728-.115.041-.058.037-.135-.013-.228-.175-.322-.823-.674-1.416-.768a1.96 1.96 0 00-.287-.024zm63.965-98.015a.458.458 0 00-.365.147 1.308 1.308 0 00-.243.319c-.063.113-.117.23-.161.353l-3.885 10.491a3.29 3.29 0 00-.1.32 3.828 3.828 0 00-.107 1.248c.013.158.042.314.087.466.029.1.071.196.125.285.09.144.197.22.31.236l.808.108c-.113-.015-.22-.092-.31-.236a1.273 1.273 0 01-.125-.285 2.308 2.308 0 01-.087-.466 3.46 3.46 0 01.002-.628 3.828 3.828 0 01.184-.883l.021-.057 3.885-10.49a2.41 2.41 0 01.161-.353 1.35 1.35 0 01.243-.32.458.458 0 01.365-.146l-.809-.109h.001z"
          fill="#121F3A"
        />
        <Path
          d="M122.721 41.667h-.009l-.808-.109a.524.524 0 01-.363-.27 1.292 1.292 0 01-.133-.301 2.457 2.457 0 01-.09-.481 3.602 3.602 0 01.001-.641c.019-.214.055-.424.108-.631.028-.11.062-.22.102-.328l3.885-10.49c.046-.126.101-.247.166-.364.068-.125.155-.238.257-.336a.53.53 0 01.424-.166l.807.108h.001c.04.006.067.042.062.082a.072.072 0 01-.081.062.39.39 0 00-.307.129 1.21 1.21 0 00-.229.301c-.061.11-.113.224-.156.342l-3.885 10.491a3.259 3.259 0 00-.098.313 3.785 3.785 0 00-.104 1.224c.013.153.041.305.085.451.027.095.066.184.117.269.075.121.162.189.258.202.04.006.068.042.062.082a.072.072 0 01-.072.063v-.002zm3.488-13.976a.423.423 0 00-.274.13c-.091.089-.169.191-.229.303-.061.109-.113.224-.156.341l-3.885 10.492-.02.055a3.784 3.784 0 00-.182 1.482c.013.152.041.304.084.45.028.095.067.185.118.27.076.12.162.188.258.202l.486.065a.902.902 0 01-.059-.082 1.292 1.292 0 01-.133-.302 2.388 2.388 0 01-.09-.481 3.363 3.363 0 01-.012-.39 3.958 3.958 0 01.121-.883c.028-.11.062-.22.102-.327l3.885-10.49c.046-.126.101-.247.166-.364.068-.125.154-.238.257-.337a.864.864 0 01.079-.065l-.483-.065a.205.205 0 00-.033-.003z"
          fill="#121F3A"
        />
        <Path
          d="M127.37 27.966c.297.477.3 1.522.004 2.32l-3.885 10.492c-.294.796-.78 1.058-1.078.58-.298-.478-.301-1.523-.006-2.319l3.885-10.49c.296-.8.782-1.062 1.081-.583h-.001z"
          fill="#75FAD4"
        />
        <Path
          d="M122.762 41.67c-.119 0-.276-.053-.413-.273-.31-.496-.315-1.565-.013-2.383l3.886-10.49c.19-.515.471-.839.753-.867.123-.013.302.024.456.271.309.496.314 1.566.01 2.385l-3.884 10.491c-.19.513-.471.836-.752.865a.493.493 0 01-.042.002l-.001-.001zm4.254-13.871l-.026.001c-.222.023-.464.32-.632.773l-3.885 10.491c-.285.767-.285 1.8 0 2.256.062.101.169.218.317.203.222-.023.464-.318.632-.77l3.885-10.491c.285-.77.286-1.803.003-2.258-.06-.096-.157-.206-.293-.206l-.001.001zm-6.653 15.72a.458.458 0 00-.365.147 1.302 1.302 0 00-.243.32c-.064.113-.117.23-.162.353l-3.885 10.491a3.023 3.023 0 00-.099.32 3.94 3.94 0 00-.12.867c-.003.127.001.254.012.38.013.16.042.315.087.467.03.1.072.196.125.285.09.144.197.22.31.235l.809.108c-.114-.015-.22-.091-.31-.235a1.235 1.235 0 01-.126-.285 2.312 2.312 0 01-.086-.466 3.227 3.227 0 01.001-.629 3.725 3.725 0 01.205-.939l3.886-10.491c.044-.121.098-.24.161-.353.064-.118.146-.226.243-.319a.458.458 0 01.365-.147l-.808-.108z"
          fill="#121F3A"
        />
        <Path
          d="M116.833 57.566h-.01l-.808-.109a.523.523 0 01-.362-.27 1.295 1.295 0 01-.134-.301 2.386 2.386 0 01-.089-.481 3.363 3.363 0 01.001-.641 3.96 3.96 0 01.107-.631c.028-.11.062-.22.102-.328l3.885-10.49c.046-.126.101-.247.167-.363.068-.125.154-.24.256-.338a.528.528 0 01.424-.165l.808.108c.04.005.068.041.062.081a.071.071 0 01-.081.062.394.394 0 00-.307.129c-.091.088-.169.19-.229.302-.061.11-.113.224-.156.342l-3.885 10.49a3.676 3.676 0 00-.201 1.537c.012.153.041.304.084.452.028.094.067.184.117.268.076.122.163.19.258.203.04.005.068.041.063.081a.073.073 0 01-.072.063v-.001zm3.487-13.976a.422.422 0 00-.274.13c-.092.09-.169.191-.229.303-.061.11-.113.224-.156.341l-3.885 10.492a2.887 2.887 0 00-.098.313 3.675 3.675 0 00-.104 1.224c.012.152.041.304.084.451.028.094.067.184.118.269.076.121.162.189.258.202l.485.065a.866.866 0 01-.058-.082 1.337 1.337 0 01-.133-.302 2.46 2.46 0 01-.09-.48 3.363 3.363 0 01.001-.642 3.96 3.96 0 01.107-.63c.029-.111.062-.22.102-.328l3.885-10.491c.046-.125.102-.246.167-.363.068-.125.154-.239.257-.337a.814.814 0 01.079-.066l-.483-.064a.204.204 0 00-.033-.003v-.002z"
          fill="#121F3A"
        />
        <Path
          d="M121.482 43.865c.298.477.3 1.522.004 2.321l-3.885 10.491c-.295.796-.781 1.058-1.078.58-.299-.478-.301-1.523-.006-2.32l3.885-10.49c.296-.8.782-1.061 1.08-.582z"
          fill="#75FAD4"
        />
        <Path
          d="M116.876 57.568c-.119 0-.276-.053-.413-.272-.31-.497-.316-1.566-.013-2.383l3.885-10.491c.191-.514.472-.838.754-.867.123-.013.302.024.456.272.309.495.313 1.565.01 2.384l-3.885 10.491c-.19.513-.471.836-.752.864-.014.002-.027.002-.042.002zm4.254-13.87l-.026.001c-.222.023-.465.32-.633.774l-3.885 10.49c-.284.768-.285 1.801 0 2.257.062.1.169.218.317.203.222-.023.464-.318.632-.77l3.884-10.492c.286-.77.287-1.803.003-2.258-.059-.095-.157-.205-.292-.205z"
          fill="#121F3A"
        />
        <Path
          d="M122.276 28.041l-62.597-9.93-30.273 82.142 62.597 9.93 30.273-82.142z"
          fill="#fff"
        />
        <Path
          d="M92.003 110.256c-.003 0-.007 0-.011-.002l-62.597-9.929a.074.074 0 01-.051-.035.075.075 0 01-.006-.062l30.273-82.141a.072.072 0 01.079-.047l62.597 9.93c.021.003.04.016.051.035a.074.074 0 01.005.061l-30.272 82.142a.072.072 0 01-.068.047v.001zm-62.498-10.06l62.451 9.906 30.221-82.003-62.451-9.907-30.221 82.004z"
          fill="#121F3A"
        />
        <Path
          d="M59.784 107.715c-3.22-.511-6.734 1.526-7.848 4.549-1.113 3.023.593 5.888 3.813 6.399 3.22.51 6.733-1.527 7.847-4.549 1.114-3.023-.593-5.889-3.813-6.399h.001zm2.698 6.222c-.9 2.445-3.742 4.092-6.347 3.679-2.604-.413-3.985-2.73-3.084-5.175.9-2.445 3.743-4.093 6.347-3.68 2.604.413 3.985 2.731 3.084 5.176z"
          fill="#286588"
        />
        <Path
          d="M56.752 118.815c-.338 0-.677-.025-1.012-.079-1.594-.253-2.872-1.077-3.601-2.322-.715-1.222-.81-2.704-.269-4.173 1.124-3.049 4.68-5.11 7.927-4.595 1.593.253 2.872 1.077 3.6 2.322.715 1.221.81 2.704.269 4.173-1.008 2.734-3.972 4.674-6.914 4.674zm2.03-11.104c-2.884 0-5.789 1.9-6.776 4.58-.526 1.428-.435 2.866.258 4.049.706 1.207 1.948 2.007 3.498 2.252 3.183.505 6.667-1.514 7.768-4.502.526-1.428.435-2.866-.258-4.05-.706-1.207-1.948-2.007-3.497-2.253a6.467 6.467 0 00-.993-.077v.001zm-1.836 10.043c-.275 0-.55-.021-.821-.064-1.293-.205-2.33-.874-2.922-1.885-.58-.992-.658-2.195-.219-3.387.91-2.472 3.794-4.144 6.426-3.726 1.293.206 2.331.875 2.922 1.885.58.992.658 2.195.219 3.388-.817 2.217-3.22 3.79-5.606 3.79v-.001zm1.642-8.982c-2.328 0-4.67 1.534-5.468 3.696-.424 1.15-.35 2.309.208 3.263.57.973 1.57 1.617 2.82 1.816 2.567.407 5.38-1.223 6.268-3.633.424-1.151.35-2.31-.208-3.264-.57-.972-1.57-1.616-2.82-1.815a5 5 0 00-.8-.062v-.001zM92.44 95.287l-3.25 8.821-9.392-1.49-.297.806 10.249 1.626 3.547-9.626-.857-.136z"
          fill="#121F3A"
        />
        <Path
          d="M89.75 105.121c-.004 0-.008 0-.012-.002l-10.248-1.625a.077.077 0 01-.051-.035.075.075 0 01-.006-.062l.297-.805a.073.073 0 01.079-.047l9.332 1.481 3.23-8.766a.072.072 0 01.079-.046l.858.136a.073.073 0 01.056.096l-3.547 9.626a.07.07 0 01-.068.047v.002zm-10.15-1.756l10.103 1.603 3.496-9.487-.712-.113-3.23 8.765a.07.07 0 01-.079.046l-9.332-1.48-.246.667v-.001zM72.18 24.877L61.93 23.25l-3.546 9.622.857.136 3.25-8.817 9.395 1.49.296-.805z"
          fill="#121F3A"
        />
        <Path
          d="M59.24 33.081l-.012-.001-.858-.136a.074.074 0 01-.05-.035.074.074 0 01-.006-.062l3.546-9.622a.072.072 0 01.079-.046l10.252 1.626a.073.073 0 01.057.097l-.297.805a.072.072 0 01-.079.047l-9.336-1.481-3.229 8.761a.072.072 0 01-.068.047zm-.76-.266l.712.113 3.229-8.762a.072.072 0 01.079-.046l9.336 1.48.246-.666-10.107-1.603-3.495 9.483zm-19.948 53.92l-3.548 9.627 10.253 1.626.296-.805-9.394-1.49 3.25-8.82-.858-.137h.001z"
          fill="#121F3A"
        />
        <Path
          d="M45.237 98.06h-.011l-10.253-1.627a.074.074 0 01-.051-.035.073.073 0 01-.006-.062l3.548-9.626a.072.072 0 01.08-.046l.857.136a.072.072 0 01.056.096l-3.22 8.738 9.307 1.477a.073.073 0 01.057.097l-.296.805a.072.072 0 01-.069.047h.001zm-10.154-1.756l10.106 1.604.246-.667-9.307-1.476a.074.074 0 01-.051-.035.074.074 0 01-.006-.062l3.22-8.738-.711-.113-3.497 9.487zm81.61-64.366l-10.248-1.625-.297.805 9.391 1.49-3.25 8.816.858.136 3.546-9.622z"
          fill="#121F3A"
        />
        <Path
          d="M113.146 41.632c-.003 0-.008 0-.011-.002l-.858-.135a.074.074 0 01-.051-.035.074.074 0 01-.006-.062l3.219-8.734-9.304-1.476a.074.074 0 01-.051-.035.07.07 0 01-.005-.062l.296-.805a.072.072 0 01.079-.047l10.248 1.626a.074.074 0 01.052.035c.01.019.012.041.005.062l-3.546 9.622a.071.071 0 01-.068.047h.001zm-.759-.267l.712.113 3.495-9.483-10.103-1.603-.246.666 9.304 1.477c.021.003.04.016.051.035a.07.07 0 01.005.061l-3.218 8.734z"
          fill="#121F3A"
        />
        <Path
          d="M9.196 25.645l.602 3.195-.86 1.875-.602-3.194a.369.369 0 01.02-.24l.86-1.877a.365.365 0 00-.02.241z"
          fill="#286588"
        />
        <Path
          d="M8.86 30.749a.085.085 0 00.155.003l.861-1.876a.083.083 0 00.006-.052l-.601-3.194v-.003a.28.28 0 01.013-.186.085.085 0 00-.154-.071l-.86 1.876a.451.451 0 00-.026.296l.601 3.19a.132.132 0 00.005.017zm.85-1.92l-.738 1.61-.552-2.933a.289.289 0 01.014-.19l.702-1.532.574 3.045z"
          fill="#121F3A"
        />
        <Path
          d="M29.244 37.893a.393.393 0 00.303-.215l-.861 1.876a.395.395 0 01-.303.215l-3.399.75.86-1.875 3.4-.75v-.001z"
          fill="#286588"
        />
        <Path
          d="M24.907 40.551c.016.038.057.06.096.05l3.4-.75a.478.478 0 00.36-.262l.861-1.876a.085.085 0 00-.042-.113.085.085 0 00-.112.041c-.04.087-.127.147-.24.167h-.004l-3.4.752a.086.086 0 00-.058.047l-.86 1.875a.084.084 0 00-.001.068v.001zm4.417-2.59l-.714 1.556c-.04.087-.128.147-.24.167l-3.236.715.771-1.682 3.356-.742a.59.59 0 00.063-.015z"
          fill="#121F3A"
        />
        <Path
          d="M8.138 34.06l-.86 1.876c.627-1.369 1.89-2.448 3.666-2.937 3.722-1.024 8.287.933 10.196 4.372.998 1.798 1.073 3.645.385 5.145l.86-1.876c.688-1.5.614-3.347-.384-5.145-1.91-3.438-6.474-5.396-10.196-4.371-1.776.489-3.039 1.568-3.667 2.936z"
          fill="#286588"
        />
        <Path
          d="M7.2 35.969a.085.085 0 00.155.002c.642-1.4 1.925-2.426 3.612-2.89 3.68-1.014 8.21.929 10.1 4.33.94 1.697 1.08 3.544.38 5.068a.085.085 0 00.042.113c.043.02.093.001.113-.041l.86-1.876c.723-1.574.582-3.477-.387-5.221-1.924-3.466-6.54-5.445-10.292-4.413-1.736.479-3.058 1.538-3.721 2.984L7.2 35.9a.087.087 0 00-.001.069zm14.36 2.07a7.227 7.227 0 00-.345-.709c-1.924-3.465-6.541-5.445-10.293-4.413-1.258.347-2.3.999-3.03 1.881l.323-.702c.642-1.4 1.925-2.426 3.613-2.89 3.68-1.014 8.21.929 10.099 4.33.942 1.697 1.081 3.544.381 5.068l-.326.71c.18-1.051.037-2.18-.423-3.276z"
          fill="#121F3A"
        />
        <Path
          d="M1.75 30.713l-.861 1.876a.397.397 0 00.027.36.603.603 0 00.181.198l.861-1.876a.596.596 0 01-.181-.198.397.397 0 01-.028-.36z"
          fill="#286588"
        />
        <Path
          d="M.814 32.931l.028.059c.049.086.12.164.208.226a.084.084 0 00.125-.035l.86-1.875a.086.086 0 00-.028-.105.514.514 0 01-.156-.17.315.315 0 01-.024-.283.085.085 0 00-.042-.113.085.085 0 00-.113.042l-.86 1.875a.47.47 0 00.003.38zm.253.078a.493.493 0 01-.077-.102.313.313 0 01-.024-.283l.714-1.556a.65.65 0 00.173.228l-.786 1.713z"
          fill="#121F3A"
        />
        <Path
          d="M1.958 31.272l-.86 1.875 3.026 2.312.86-1.876-3.026-2.311z"
          fill="#286588"
        />
        <Path
          d="M1.019 33.18a.088.088 0 00.026.034l3.027 2.312c.037.028.09.02.118-.017l.01-.015.86-1.876a.085.085 0 00-.025-.103l-3.027-2.312a.084.084 0 00-.128.032l-.86 1.876a.087.087 0 00-.002.068zm3.071 2.146L1.202 33.12l.788-1.718 2.888 2.206-.788 1.718z"
          fill="#121F3A"
        />
        <Path
          d="M27.915 45.86a.325.325 0 01-.032.056l-1.53 2.158.861-1.876 1.53-2.157a.325.325 0 00.032-.057l-.86 1.876z"
          fill="#286588"
        />
        <Path
          d="M26.276 48.107a.085.085 0 00.147.016l1.53-2.157a.44.44 0 00.04-.07l.86-1.874v-.001a.086.086 0 00-.041-.113.084.084 0 00-.113.042.258.258 0 01-.024.042l-1.53 2.158a.098.098 0 00-.007.014l-.86 1.875a.086.086 0 00-.002.069zm2.032-3.304l-.47 1.023a.252.252 0 01-.023.041l-1.006 1.418.479-1.043 1.02-1.439z"
          fill="#121F3A"
        />
        <Path
          d="M4.984 33.582l-.86 1.876a7.14 7.14 0 00-.304 2.475l.86-1.876c-.041-.855.061-1.689.304-2.475z"
          fill="#286588"
        />
        <Path
          d="M3.743 37.967a.084.084 0 00.155.002l.86-1.875a.09.09 0 00.009-.04 7.08 7.08 0 01.3-2.446.085.085 0 00-.057-.106.085.085 0 00-.102.045l-.86 1.876a7.24 7.24 0 00-.312 2.515c0 .01.002.02.007.03zm.853-1.925l-.7 1.524c0-.715.103-1.413.308-2.077l.494-1.075a7.38 7.38 0 00-.101 1.628h-.001z"
          fill="#121F3A"
        />
        <Path
          d="M23.054 44.623l-.86 1.876 3.484 1.667.86-1.876-3.484-1.667z"
          fill="#286588"
        />
        <Path
          d="M22.116 46.531c.008.02.023.035.042.044l3.484 1.667c.042.02.093.003.113-.04v-.001l.861-1.876a.085.085 0 00-.04-.113l-3.485-1.666a.084.084 0 00-.113.04v.001l-.86 1.876a.085.085 0 00-.002.068zm3.522 1.52l-3.332-1.593.79-1.721 3.331 1.593-.79 1.721z"
          fill="#121F3A"
        />
        <Path
          d="M26.538 46.29l-.86 1.876c.251.131.545.093.675-.091l.86-1.876c-.13.184-.423.223-.675.09z"
          fill="#286588"
        />
        <Path
          d="M25.6 48.2a.085.085 0 00.038.041c.292.154.629.103.784-.117l.008-.013.86-1.876a.085.085 0 00-.146-.085c-.104.148-.353.177-.566.065a.085.085 0 00-.114.036l-.002.004-.86 1.875a.084.084 0 00-.002.069zm.68-.168c-.095.127-.297.162-.489.092l.79-1.721a.699.699 0 00.433.03l-.734 1.6z"
          fill="#121F3A"
        />
        <Path
          d="M20.726 45.862l-.86 1.876a8.423 8.423 0 002.327-1.24l.86-1.875a8.42 8.42 0 01-2.327 1.24z"
          fill="#286588"
        />
        <Path
          d="M19.788 47.77a.084.084 0 00.107.048 8.495 8.495 0 002.35-1.252.08.08 0 00.025-.032l.861-1.876a.085.085 0 00-.128-.103 8.333 8.333 0 01-2.304 1.227.084.084 0 00-.05.044l-.86 1.876a.085.085 0 00-.001.069zm2.338-1.327a8.256 8.256 0 01-2.097 1.145l.76-1.657a8.622 8.622 0 002.053-1.047l-.715 1.56z"
          fill="#121F3A"
        />
        <Path
          d="M6.189 40.531l-.86 1.876A11.77 11.77 0 007.23 44.67l.861-1.876a11.745 11.745 0 01-1.902-2.263z"
          fill="#286588"
        />
        <Path
          d="M5.252 42.44a11.863 11.863 0 001.923 2.292.084.084 0 00.134-.028l.86-1.876a.086.086 0 00-.019-.097 11.692 11.692 0 01-1.889-2.247.085.085 0 00-.149.01l-.86 1.876a.087.087 0 00-.001.068v.001zm1.953 2.087A11.675 11.675 0 015.427 42.4l.776-1.694a11.856 11.856 0 001.788 2.108l-.786 1.713z"
          fill="#121F3A"
        />
        <Path
          d="M.967 37.3l.93 2.755-.86 1.876-.93-2.755a.373.373 0 01.008-.277l.861-1.876a.37.37 0 00-.01.278z"
          fill="#286588"
        />
        <Path
          d="M.96 41.965a.084.084 0 00.155.002l.86-1.875a.084.084 0 00.003-.063l-.93-2.754a.288.288 0 01.006-.215.085.085 0 00-.154-.07l-.86 1.875a.455.455 0 00-.013.34l.93 2.755.003.006zm.847-1.913l-.757 1.651-.863-2.553a.288.288 0 01.006-.214l.713-1.553.901 2.669z"
          fill="#121F3A"
        />
        <Path
          d="M2.513 40.46l-.86 1.877 3.677.07.86-1.875-3.677-.07v-.001z"
          fill="#286588"
        />
        <Path
          d="M1.575 42.37c.013.03.043.05.076.051l3.678.07a.084.084 0 00.078-.049l.86-1.876a.085.085 0 00-.075-.12l-3.677-.071a.084.084 0 00-.078.05L1.576 42.3a.087.087 0 00-.001.068v.001zm3.701-.05l-3.492-.066.783-1.707 3.492.067-.783 1.707z"
          fill="#121F3A"
        />
        <Path
          d="M1.898 40.057l-.86 1.875c.009.029.02.056.035.082a.668.668 0 00.578.323l.861-1.876a.668.668 0 01-.578-.323.49.49 0 01-.036-.081z"
          fill="#286588"
        />
        <Path
          d="M.972 41.997a.757.757 0 00.682.424c.033 0 .062-.02.075-.05l.861-1.875a.086.086 0 00-.079-.121.58.58 0 01-.502-.28.44.44 0 01-.03-.067.084.084 0 00-.157-.008L.96 41.896a.087.087 0 00-.004.063.492.492 0 00.015.038zm.627.252a.58.58 0 01-.469-.315l.775-1.688c.11.15.29.257.48.289L1.6 42.249z"
          fill="#121F3A"
        />
        <Path
          d="M12.71 45.617l-.86 1.876c.978.36 1.986.605 2.993.728l.86-1.876a13.348 13.348 0 01-2.993-.728z"
          fill="#286588"
        />
        <Path
          d="M11.772 47.525c.01.022.027.039.049.047.984.363 1.998.61 3.012.733a.085.085 0 00.088-.049l.86-1.876a.086.086 0 00-.067-.12 13.267 13.267 0 01-2.974-.724.085.085 0 00-.106.044l-.86 1.876a.087.087 0 00-.002.069zm3.02.603c-.95-.12-1.901-.35-2.826-.684l.79-1.721c.923.334 1.872.567 2.823.691l-.787 1.714z"
          fill="#121F3A"
        />
        <Path
          d="M15.704 46.344l-.86 1.876 1.525 3.106.86-1.875-1.524-3.107z"
          fill="#286588"
        />
        <Path
          d="M14.765 48.253l.002.005 1.525 3.106c.02.043.071.06.113.039a.087.087 0 00.04-.04l.86-1.876a.084.084 0 000-.073l-1.525-3.107a.084.084 0 00-.114-.038.087.087 0 00-.04.04l-.86 1.876a.084.084 0 00-.002.068h.001zm1.6 2.876l-1.428-2.91.77-1.677 1.428 2.91-.77 1.677z"
          fill="#121F3A"
        />
        <Path
          d="M20.963 49.518c.165-.017.29-.103.345-.223l-.86 1.875c-.056.12-.18.206-.346.223l-3.092.296.86-1.876 3.092-.295h.001z"
          fill="#286588"
        />
        <Path
          d="M16.934 51.723c.014.035.05.055.086.052l3.093-.296c.19-.019.344-.12.413-.271l.86-1.876a.085.085 0 00-.04-.113.085.085 0 00-.113.042c-.044.096-.148.16-.276.173l-3.093.296a.085.085 0 00-.068.05l-.86 1.874a.084.084 0 00-.002.069zm4.151-2.142l-.713 1.555c-.044.096-.147.16-.276.174l-2.945.282.779-1.697 3.043-.292a.582.582 0 00.112-.022z"
          fill="#121F3A"
        />
        <Path
          d="M17.228 49.451l-.86 1.876c.135.25.396.387.642.363l.86-1.875a.676.676 0 01-.643-.364"
          fill="#286588"
        />
        <Path
          d="M16.29 51.359l.004.008a.764.764 0 00.724.407.085.085 0 00.07-.049l.86-1.876a.086.086 0 00-.085-.12.593.593 0 01-.56-.32.085.085 0 00-.151.006l-.861 1.876a.086.086 0 00-.001.068zm.665.249a.597.597 0 01-.492-.287l.78-1.7a.771.771 0 00.496.276l-.784 1.71z"
          fill="#121F3A"
        />
        <Path
          d="M6.753 45.549l-.86 1.876a.395.395 0 00.027.358.614.614 0 00.22.223L7 46.13a.618.618 0 01-.22-.223.394.394 0 01-.027-.358z"
          fill="#286588"
        />
        <Path
          d="M5.818 47.766a.699.699 0 00.277.311c.04.024.093.012.117-.028l.004-.009.861-1.875a.085.085 0 00-.033-.108.532.532 0 01-.19-.192.313.313 0 01-.023-.281.085.085 0 00-.155-.072l-.86 1.876a.469.469 0 00.002.378zm.288.11a.497.497 0 01-.111-.135.31.31 0 01-.024-.281l.714-1.557a.68.68 0 00.209.257l-.788 1.716z"
          fill="#121F3A"
        />
        <Path
          d="M10.537 47.826l-.861 1.876 2.174-2.209.861-1.876-2.175 2.21z"
          fill="#286588"
        />
        <Path
          d="M9.597 49.735a.085.085 0 00.138.026l2.175-2.209a.097.097 0 00.016-.024l.861-1.876a.085.085 0 00-.137-.095l-2.175 2.209a.094.094 0 00-.017.024l-.86 1.876a.087.087 0 00-.002.068zm2.182-2.292l-1.825 1.855.652-1.423 1.825-1.854-.652 1.422z"
          fill="#121F3A"
        />
        <Path
          d="M7 46.129l-.861 1.876 2.843 1.737.861-1.876L7 46.129z"
          fill="#286588"
        />
        <Path
          d="M6.062 48.038c.006.016.018.03.033.04l2.844 1.737c.04.024.092.011.116-.029l.005-.008.861-1.876a.085.085 0 00-.033-.108l-2.844-1.737a.085.085 0 00-.116.029l-.005.008-.86 1.876a.087.087 0 00-.002.068zm2.884 1.582L6.25 47.972l.789-1.72L9.735 47.9l-.789 1.72z"
          fill="#121F3A"
        />
        <Path
          d="M9.843 47.867l-.86 1.876c.241.147.542.13.692-.041l.86-1.876c-.15.171-.45.188-.692.041z"
          fill="#286588"
        />
        <Path
          d="M8.905 49.775c.007.016.019.03.034.04.279.17.623.145.8-.058a.075.075 0 00.014-.02l.86-1.876a.086.086 0 00-.04-.113.084.084 0 00-.1.021c-.122.139-.379.15-.585.025a.085.085 0 00-.116.028l-.005.009-.86 1.876a.084.084 0 00-.002.068zm.7-.122c-.112.118-.324.136-.511.051l.79-1.721c.154.07.32.086.465.048l-.744 1.622z"
          fill="#121F3A"
        />
        <Path
          d="M9.561 25.183c-.263.025-.42.225-.364.462l.601 3.194a8.412 8.412 0 00-2.328 1.238L3.988 28.41c-.253-.131-.545-.09-.676.093l-1.53 2.156c-.085.12-.081.276-.004.415a.604.604 0 00.181.198l3.027 2.311a7.14 7.14 0 00-.304 2.476l-3.4.749c-.255.044-.391.26-.312.493l.93 2.755c.01.028.022.056.036.082a.668.668 0 00.578.322l3.678.071a11.77 11.77 0 001.902 2.263l-1.327 2.73a.39.39 0 00.015.383.613.613 0 00.22.223l2.843 1.736c.242.148.542.13.692-.04l2.175-2.21c.979.36 1.986.606 2.993.728l1.525 3.107c.136.249.397.387.643.363l3.092-.296c.262-.026.422-.227.364-.462l-.601-3.194a8.423 8.423 0 002.328-1.24l3.484 1.667c.251.132.546.093.675-.09l1.53-2.158c.085-.12.081-.275.004-.414a.615.615 0 00-.18-.199L25.54 41.12a7.13 7.13 0 00.305-2.476l3.4-.75c.255-.046.39-.26.311-.493l-.928-2.754a.492.492 0 00-.036-.082.664.664 0 00-.58-.322l-3.675-.071a11.85 11.85 0 00-1.903-2.263l1.327-2.73a.388.388 0 00-.015-.381.62.62 0 00-.22-.224l-2.843-1.74c-.242-.147-.544-.13-.693.042l-2.176 2.21a13.4 13.4 0 00-2.993-.728L13.3 25.251a.678.678 0 00-.644-.366l-3.093.298h-.001zM8.524 39.205c-1.91-3.439-.44-7.057 3.282-8.081 3.722-1.025 8.287.933 10.196 4.371 1.91 3.44.44 7.057-3.282 8.082-3.722 1.025-8.286-.933-10.196-4.372z"
          fill="#75FAD4"
        />
        <Path
          d="M1.833 40.12c.008.02.017.04.028.059.122.22.39.37.653.366l3.63.07a11.82 11.82 0 001.845 2.198l-1.3 2.674a.468.468 0 00.018.462c.056.1.142.189.25.253L9.8 47.94c.28.17.623.145.8-.057l2.134-2.167a13.42 13.42 0 002.915.708l1.504 3.065c.15.274.441.438.727.41l3.093-.295a.51.51 0 00.374-.203.442.442 0 00.065-.363l-.587-3.119c.83-.298 1.583-.7 2.24-1.196l3.439 1.644c.288.152.625.102.78-.118l1.53-2.157a.464.464 0 00.009-.505.693.693 0 00-.206-.226l-2.978-2.272a7.198 7.198 0 00.294-2.377l3.33-.736a.483.483 0 00.34-.223.453.453 0 00.034-.38l-.929-2.754a.572.572 0 00-.042-.095.751.751 0 00-.655-.366l-3.628-.07a11.917 11.917 0 00-1.845-2.198l1.299-2.674a.466.466 0 00-.017-.46.7.7 0 00-.251-.255l-2.843-1.74c-.28-.17-.624-.145-.8.058l-2.135 2.167a13.48 13.48 0 00-2.915-.707l-1.503-3.066c-.15-.275-.441-.44-.727-.412l-3.094.298a.505.505 0 00-.372.2.444.444 0 00-.066.366l.587 3.12a8.501 8.501 0 00-2.242 1.194l-3.436-1.645c-.288-.15-.625-.1-.781.12l-1.53 2.156a.468.468 0 00-.01.505c.049.087.12.165.208.226l2.976 2.274a7.236 7.236 0 00-.293 2.376l-3.33.734a.484.484 0 00-.342.224.45.45 0 00-.033.38l.93 2.754a.49.49 0 00.015.038zm6.337 2.64a.09.09 0 00-.02-.029 11.686 11.686 0 01-1.89-2.246.084.084 0 00-.07-.04l-3.676-.07a.582.582 0 01-.505-.28.44.44 0 01-.03-.067l-.931-2.754a.286.286 0 01.018-.239.322.322 0 01.229-.144l3.404-.75a.085.085 0 00.066-.088 7.08 7.08 0 01.3-2.446.086.086 0 00-.03-.093l-3.026-2.312a.527.527 0 01-.16-.171c-.063-.114-.063-.235 0-.324l1.53-2.156c.106-.148.355-.178.568-.067l3.486 1.668c.028.014.062.01.088-.009a8.349 8.349 0 012.304-1.225.085.085 0 00.056-.096l-.602-3.194a.277.277 0 01.038-.232.34.34 0 01.251-.13l3.093-.298c.22-.02.445.108.56.32l1.522 3.105a.085.085 0 00.066.047 13.27 13.27 0 012.973.722.084.084 0 00.09-.02l2.176-2.21c.125-.143.381-.154.588-.028l2.843 1.74c.083.05.149.117.19.192.058.104.064.213.016.299l-1.329 2.734a.085.085 0 00.019.1c.74.69 1.376 1.445 1.889 2.246a.084.084 0 00.07.04l3.676.07a.58.58 0 01.507.28.419.419 0 01.03.067l.927 2.753a.285.285 0 01-.018.24.32.32 0 01-.227.142l-3.403.752a.085.085 0 00-.067.087c.042.846-.06 1.67-.301 2.446a.085.085 0 00.03.093l3.026 2.31a.534.534 0 01.159.172c.064.115.064.233 0 .323l-1.53 2.158c-.104.148-.353.177-.567.064l-3.487-1.668a.085.085 0 00-.088.01 8.328 8.328 0 01-2.304 1.226.085.085 0 00-.056.096l.602 3.195a.272.272 0 01-.037.228.344.344 0 01-.253.133l-3.092.296a.593.593 0 01-.56-.32l-1.523-3.103a.085.085 0 00-.066-.047 13.266 13.266 0 01-2.974-.724.084.084 0 00-.09.02l-2.174 2.209c-.126.142-.382.153-.588.028l-2.844-1.737a.527.527 0 01-.19-.192c-.057-.104-.063-.213-.014-.3l1.33-2.734a.084.084 0 00.001-.07l.001.003zm-.076-4.242c.105.25.224.492.355.73 1.924 3.465 6.541 5.444 10.293 4.412 1.804-.497 3.15-1.61 3.788-3.137.654-1.562.492-3.362-.455-5.068-1.924-3.465-6.54-5.445-10.292-4.412-1.805.497-3.15 1.61-3.789 3.137-.56 1.34-.521 2.857.1 4.339v-.001zm14.18-2.268c.604 1.439.643 2.909.1 4.207-.618 1.477-1.924 2.556-3.678 3.039-3.68 1.013-8.21-.93-10.099-4.332-.922-1.66-1.08-3.406-.447-4.919.618-1.477 1.924-2.556 3.678-3.038 3.68-1.013 8.21.93 10.1 4.33.127.232.243.47.346.713zM40.347 44.657l46.6-10.184-8.316 4.488-46.6 10.184 8.316-4.488z"
          fill="#121F3A"
        />
        <Path
          d="M32.031 49.218a.073.073 0 01-.072-.073c0-.026.015-.05.038-.063l8.315-4.488a.105.105 0 01.019-.008l46.6-10.184a.072.072 0 01.05.135l-8.316 4.488a.097.097 0 01-.018.007l-46.6 10.185a.066.066 0 01-.016.001zm8.342-4.492l-7.855 4.239 46.088-10.073 7.854-4.239-46.087 10.073z"
          fill="#121F3A"
        />
        <Path
          d="M40.347 44.658l-8.315 4.488-1.323-1.208 9.677-5.223"
          fill="#286588"
        />
        <Path
          d="M32.032 49.218a.073.073 0 01-.048-.019l-1.324-1.208a.072.072 0 01.015-.117l9.677-5.223a.072.072 0 01.098.03.072.072 0 01-.029.097l-9.588 5.175 1.21 1.105 8.27-4.464a.072.072 0 11.07.128l-8.316 4.488a.073.073 0 01-.034.008z"
          fill="#121F3A"
        />
        <Path
          d="M40.347 44.659l7.409 17.95-.187 21.707-15.007-13.803.187-21.707 7.598-4.148z"
          fill="#75FAD4"
        />
        <Path
          d="M47.569 84.389a.07.07 0 01-.049-.02L32.514 70.566a.073.073 0 01-.024-.054l.187-21.707c0-.026.014-.05.038-.063l7.597-4.147a.073.073 0 01.101.036l7.409 17.95a.077.077 0 01.005.029l-.186 21.706c0 .04-.033.072-.073.072zM32.635 70.48l14.863 13.672.185-21.53L40.31 44.76l-7.49 4.089-.187 21.632z"
          fill="#121F3A"
        />
        <Path
          d="M35.871 69.25l.106-12.357 8.506 7.824-.106 12.357-8.506-7.824z"
          fill="#286588"
        />
        <Path
          d="M44.377 77.147a.07.07 0 01-.049-.02l-8.506-7.824a.073.073 0 01-.023-.054l.106-12.357a.072.072 0 01.121-.053l8.506 7.825a.073.073 0 01.023.054l-.106 12.357c0 .04-.032.072-.072.072zm-8.434-7.928l8.363 7.692.104-12.162-8.362-7.693-.105 12.163z"
          fill="#121F3A"
        />
        <Path
          d="M41.433 62.763l-2.422-2.228-.091 10.67 2.422 2.228.091-10.67z"
          fill="#fff"
        />
        <Path
          d="M41.342 73.505a.07.07 0 01-.05-.019l-2.42-2.228a.073.073 0 01-.024-.053l.091-10.67c0-.04.033-.072.073-.072.018 0 .035.007.048.02l2.422 2.227a.073.073 0 01.024.054l-.092 10.67c0 .04-.032.071-.072.071zm-2.35-2.332l2.279 2.096.09-10.475-2.278-2.095-.09 10.475z"
          fill="#121F3A"
        />
        <Path
          d="M39.011 60.534l-2.421-2.227-.092 10.67 2.422 2.227.091-10.67z"
          fill="#fff"
        />
        <Path
          d="M38.92 71.277a.07.07 0 01-.049-.02L36.45 69.03a.073.073 0 01-.023-.054l.091-10.67c0-.028.018-.054.044-.066a.072.072 0 01.078.014l2.421 2.227a.073.073 0 01.024.054l-.092 10.67c0 .04-.032.072-.072.072zm-2.35-2.332l2.279 2.096.09-10.474-2.278-2.097-.09 10.475z"
          fill="#121F3A"
        />
        <Path
          d="M43.855 64.99l-2.422-2.228-.091 10.67 2.422 2.227.091-10.67z"
          fill="#fff"
        />
        <Path
          d="M43.764 75.732a.07.07 0 01-.05-.02l-2.421-2.227a.073.073 0 01-.023-.054l.091-10.67c0-.04.033-.072.073-.072.018 0 .035.008.048.02l2.422 2.228a.072.072 0 01.024.053l-.092 10.67c0 .04-.033.072-.072.072zm-2.35-2.332l2.279 2.096.09-10.475-2.279-2.096-.09 10.475z"
          fill="#121F3A"
        />
        <Path
          d="M40.348 44.658l46.67-10.666 7.409 17.951-46.671 10.666-7.408-17.95z"
          fill="#fff"
        />
        <Path
          d="M47.756 62.682a.072.072 0 01-.067-.045l-7.408-17.95a.073.073 0 01.051-.1l46.67-10.665c.035-.008.07.01.084.043l7.408 17.95a.073.073 0 01-.05.099L47.771 62.68a.075.075 0 01-.016.002zM40.447 44.71L47.8 62.526l46.528-10.634-7.352-17.816L40.447 44.71z"
          fill="#121F3A"
        />
        <Path
          d="M47.755 62.61l46.671-10.667-.187 21.707-46.67 10.666.186-21.707z"
          fill="#fff"
        />
        <Path
          d="M47.568 84.389a.072.072 0 01-.072-.072v-.001l.187-21.707c0-.034.023-.063.056-.07l46.67-10.666a.072.072 0 01.09.071l-.187 21.707a.072.072 0 01-.056.07L47.585 84.387a.075.075 0 01-.017.002zm.259-21.721l-.186 21.557 46.527-10.633.185-21.558-46.526 10.634z"
          fill="#121F3A"
        />
        <Path
          d="M60.084 63.803l-7.829 1.789-.152 17.687 7.829-1.79.152-17.686z"
          fill="#286588"
        />
        <Path
          d="M52.104 83.351a.072.072 0 01-.073-.072l.152-17.688c0-.034.024-.063.056-.07l7.829-1.789a.073.073 0 01.088.072l-.152 17.687a.072.072 0 01-.056.07l-7.828 1.788a.076.076 0 01-.016.002zm.224-17.701l-.15 17.538 7.682-1.756.15-17.538-7.682 1.755z"
          fill="#121F3A"
        />
        <Path
          d="M59.357 64.783l-6.39 1.46-.063 7.325 6.39-1.46.063-7.325"
          fill="#75FAD4"
        />
        <Path
          d="M52.904 73.64a.072.072 0 01-.072-.071v-.001l.063-7.325c0-.033.024-.063.056-.07l6.39-1.46a.073.073 0 01.089.071l-.064 7.325a.072.072 0 01-.056.07l-6.39 1.46a.074.074 0 01-.016.002zm.135-7.338l-.061 7.175 6.245-1.427.061-7.175-6.245 1.427z"
          fill="#121F3A"
        />
        <Path
          d="M59.273 74.508l-6.39 1.46-.055 6.469 6.39-1.46.055-6.47z"
          fill="#75FAD4"
        />
        <Path
          d="M52.828 82.51a.072.072 0 01-.072-.073l.055-6.47c0-.033.024-.062.056-.07l6.39-1.46a.073.073 0 01.089.072l-.056 6.468a.072.072 0 01-.056.07l-6.39 1.46a.07.07 0 01-.016.002zm.127-6.484l-.054 6.32 6.245-1.428.054-6.319-6.245 1.427zM53.068 74.234a.629.629 0 00-.472.573c-.003.258.206.42.464.36a.63.63 0 00.473-.574c.002-.259-.206-.42-.465-.36"
          fill="#121F3A"
        />
        <Path
          d="M52.954 75.252a.43.43 0 01-.274-.093.437.437 0 01-.157-.353.704.704 0 01.53-.643.458.458 0 01.396.079.435.435 0 01.156.351c-.002.29-.24.578-.529.645a.593.593 0 01-.122.014zm.22-.959c-.03 0-.06.004-.09.01a.552.552 0 00-.415.505c0 .1.035.184.102.237.07.057.168.075.274.051a.555.555 0 00.417-.505c0-.099-.036-.183-.103-.237a.289.289 0 00-.184-.061z"
          fill="#121F3A"
        />
        <Path
          d="M40.387 42.713l9.121 22.393-1.32-1.206-7.84-19.243"
          fill="#286588"
        />
        <Path
          d="M49.508 65.18a.073.073 0 01-.049-.02l-1.32-1.205a.077.077 0 01-.018-.026l-7.84-19.243a.072.072 0 01.04-.095.072.072 0 01.094.04l7.833 19.229 1.072.978-9-22.096a.072.072 0 01.04-.094.072.072 0 01.094.04l9.121 22.393a.073.073 0 01-.067.1v-.002z"
          fill="#121F3A"
        />
        <Path
          d="M40.387 42.714l46.6-10.185 9.12 22.393-46.6 10.185-9.12-22.393z"
          fill="#75FAD4"
        />
        <Path
          d="M49.508 65.18a.073.073 0 01-.067-.046L40.32 42.741a.072.072 0 01.051-.098l46.6-10.184c.034-.008.07.01.082.043l9.122 22.393a.073.073 0 01-.052.099l-46.6 10.184a.066.066 0 01-.015.002zm-9.022-22.414l9.066 22.257L96.008 54.87l-9.066-22.257-46.456 10.153z"
          fill="#121F3A"
        />
        <Path
          d="M85.036 49.827l-5.37-5.253 14.78 7.622 5.37 5.254-14.78-7.623z"
          fill="#fff"
        />
        <Path
          d="M99.817 57.522a.074.074 0 01-.033-.008l-14.781-7.622a.06.06 0 01-.018-.013l-5.37-5.253a.074.074 0 01-.008-.094.073.073 0 01.092-.022l14.78 7.622a.077.077 0 01.018.012l5.37 5.254a.073.073 0 01-.05.124zm-14.738-7.754l14.343 7.396-5.017-4.908L80.06 44.86l5.018 4.908z"
          fill="#121F3A"
        />
        <Path
          d="M85.034 49.829l14.781 7.622-.208 21.554-29.773 6.703.208-21.556 14.992-14.324z"
          fill="#fff"
        />
        <Path
          d="M69.834 85.78a.072.072 0 01-.072-.072v-.001l.208-21.555c0-.02.008-.038.022-.052l14.992-14.324a.073.073 0 01.084-.012l14.78 7.622c.025.012.04.037.04.065l-.208 21.555a.072.072 0 01-.057.07L69.85 85.778a.07.07 0 01-.016.001zm.28-21.596l-.206 21.433 29.628-6.67.207-21.453-14.695-7.578-14.933 14.268z"
          fill="#121F3A"
        />
        <Path
          d="M77.056 67.578l15.668-3.527-.115 11.882-15.668 3.527.115-11.882z"
          fill="#286588"
        />
        <Path
          d="M76.942 79.533a.072.072 0 01-.073-.072l.115-11.884c0-.033.023-.062.056-.07l15.668-3.527a.072.072 0 01.088.072l-.114 11.882a.072.072 0 01-.057.07l-15.668 3.527a.07.07 0 01-.015.002zm.186-11.897l-.113 11.734 15.523-3.494.114-11.734-15.524 3.494z"
          fill="#121F3A"
        />
        <Path
          d="M87.286 65.919l-4.805 1.08-.102 10.596 4.805-1.082.102-10.595"
          fill="#75FAD4"
        />
        <Path
          d="M82.379 77.668a.072.072 0 01-.072-.072v-.001l.102-10.596c0-.033.024-.062.057-.07l4.805-1.081a.072.072 0 01.088.07l-.103 10.596a.072.072 0 01-.056.07l-4.805 1.082a.07.07 0 01-.016.002zm.174-10.61l-.1 10.447 4.66-1.049.1-10.447-4.66 1.05z"
          fill="#121F3A"
        />
        <Path
          d="M82.482 67l-4.805 1.082-.103 10.595 4.805-1.08L82.482 67"
          fill="#75FAD4"
        />
        <Path
          d="M77.574 78.75a.072.072 0 01-.072-.072l.102-10.596c0-.034.024-.063.057-.07l4.805-1.082a.072.072 0 01.088.07l-.102 10.596a.072.072 0 01-.057.07l-4.805 1.082a.07.07 0 01-.016.002zm.175-10.61l-.101 10.447 4.66-1.049.1-10.447-4.66 1.05z"
          fill="#121F3A"
        />
        <Path
          d="M92.091 64.836l-4.805 1.082-.102 10.595 4.805-1.082.102-10.595z"
          fill="#75FAD4"
        />
        <Path
          d="M87.184 76.586a.072.072 0 01-.073-.072v-.001l.103-10.596c0-.033.023-.062.056-.07l4.805-1.081a.072.072 0 01.088.07l-.102 10.596a.072.072 0 01-.057.07L87.2 76.584a.07.07 0 01-.015.002zm.174-10.61l-.1 10.447 4.66-1.049.1-10.447-4.66 1.049z"
          fill="#121F3A"
        />
        <Path
          d="M69.835 85.707l-5.37-5.253.208-21.556 5.37 5.253-.208 21.556z"
          fill="#75FAD4"
        />
        <Path
          d="M69.835 85.78a.073.073 0 01-.05-.021l-5.37-5.253a.071.071 0 01-.022-.053l.208-21.555c0-.04.033-.072.073-.072.018 0 .036.008.049.02l5.37 5.254a.072.072 0 01.021.052l-.208 21.555c0 .04-.032.072-.072.072zm-5.297-5.356l5.226 5.113.206-21.354-5.226-5.113-.206 21.354z"
          fill="#121F3A"
        />
        <Path
          d="M70.044 64.151l-5.37-5.253 14.992-14.324 5.37 5.253-14.992 14.325z"
          fill="#fff"
        />
        <Path
          d="M70.044 64.224a.074.074 0 01-.051-.02l-5.37-5.253a.073.073 0 01-.001-.103l.002-.002 14.992-14.324a.073.073 0 01.1 0l5.37 5.253a.073.073 0 01.002.103l-.002.002-14.992 14.324a.073.073 0 01-.05.02zM64.778 58.9l5.266 5.152 14.888-14.224-5.266-5.151-14.888 14.223z"
          fill="#121F3A"
        />
        <Path
          d="M85.055 47.902l18.417 9.502-2.606.586-15.83-8.162-16.056 15.34-2.61.587 18.685-17.853z"
          fill="#286588"
        />
        <Path
          d="M66.37 65.827a.073.073 0 01-.073-.072.07.07 0 01.022-.052L85.005 47.85a.073.073 0 01.083-.012l18.417 9.502a.073.073 0 01.031.097.071.071 0 01-.048.038l-2.606.587a.07.07 0 01-.048-.006l-15.784-8.14-16.02 15.305a.073.073 0 01-.034.018l-2.61.588a.07.07 0 01-.016.002v-.002zM85.067 47.99l-18.46 17.636 2.338-.526 16.042-15.325a.073.073 0 01.083-.012l15.806 8.15 2.386-.537-18.194-9.386z"
          fill="#121F3A"
        />
        <Path
          d="M72.563 35.682l12.492 12.22-18.686 17.853-3.617-3.538 9.812-26.535z"
          fill="#75FAD4"
        />
        <Path
          d="M66.37 65.828a.074.074 0 01-.052-.02l-3.616-3.54a.073.073 0 01-.018-.077l9.812-26.534a.072.072 0 01.118-.027l12.492 12.22a.073.073 0 01.001.103l-.002.002L66.42 65.808a.073.073 0 01-.05.02zm-3.534-3.63l3.534 3.457L84.95 47.902l-12.358-12.09-9.757 26.386z"
          fill="#121F3A"
        />
        <Path
          d="M85.056 47.904l18.417 9.501-3.617-3.538-27.291-18.183 12.491 12.22z"
          fill="#75FAD4"
        />
        <Path
          d="M103.473 57.476a.078.078 0 01-.033-.008l-18.417-9.501a.06.06 0 01-.017-.013l-12.492-12.22a.072.072 0 010-.103.072.072 0 01.091-.01l27.291 18.184a.07.07 0 01.01.008l3.618 3.539a.072.072 0 010 .103.07.07 0 01-.051.021zm-18.374-9.633l17.979 9.276-3.267-3.197-26.642-17.75L85.1 47.842z"
          fill="#121F3A"
        />
        <Path
          d="M25.612 21.254a.332.332 0 01-.247-.082L23.959 19.9c.063.057.15.088.248.082l1.799-.117 1.405 1.273-1.799.116z"
          fill="#75FAD4"
        />
        <Path
          d="M27.496 21.122a.083.083 0 00-.027-.046l-1.405-1.273a.082.082 0 00-.063-.021l-1.799.116a.25.25 0 01-.185-.06.085.085 0 00-.12.006.086.086 0 00.006.121l1.406 1.273a.418.418 0 00.31.104l1.799-.117a.085.085 0 00.077-.102zm-1.519-1.168l1.23 1.113-1.599.104a.25.25 0 01-.185-.06l-1.155-1.046 1.71-.11z"
          fill="#121F3A"
        />
        <Path
          d="M37.676 10.455l.627-1.843a.427.427 0 00.01-.252.328.328 0 00-.094-.153l1.405 1.273c.045.04.076.093.094.152a.428.428 0 01-.01.253l-.627 1.843-1.405-1.273z"
          fill="#75FAD4"
        />
        <Path
          d="M39.81 9.644l-.008-.035a.408.408 0 00-.118-.193l-1.406-1.273a.084.084 0 00-.12.006.086.086 0 00.007.121.246.246 0 01.069.112.346.346 0 01-.009.202l-.627 1.842a.086.086 0 00.024.091l1.405 1.273a.085.085 0 00.137-.036l.627-1.842a.529.529 0 00.02-.269zm-1.397-1.149l1.157 1.048a.242.242 0 01.069.113.34.34 0 01-.01.2l-.585 1.72-1.268-1.148.609-1.789a.56.56 0 00.028-.144z"
          fill="#121F3A"
        />
        <Path
          d="M30.446 19.27l1.406 1.273a2.554 2.554 0 01-.736-1.199 3.142 3.142 0 01-.105-1.104c.116-1.551 1.311-3.043 2.821-3.52 1.096-.348 2.106-.12 2.78.49l-1.405-1.272c-.675-.611-1.684-.84-2.78-.492-1.51.477-2.705 1.97-2.822 3.521-.03.398.01.77.105 1.105.138.48.395.889.736 1.199z"
          fill="#75FAD4"
        />
        <Path
          d="M36.697 15.195a.082.082 0 00-.027-.047h-.001l-1.404-1.272c-.737-.667-1.78-.853-2.864-.51-1.55.49-2.76 2.002-2.88 3.596-.029.398.007.78.11 1.134.138.486.401.914.76 1.24l1.404 1.271.001.002a.085.085 0 00.12-.007.086.086 0 00-.006-.12 2.479 2.479 0 01-.71-1.16 3.06 3.06 0 01-.103-1.073c.115-1.527 1.276-2.977 2.762-3.446 1.024-.324 2.008-.152 2.698.474a.085.085 0 00.14-.081v-.001zm-6.956 2.638a3.15 3.15 0 01-.05-.858c.115-1.527 1.277-2.977 2.762-3.446 1.024-.324 2.008-.151 2.699.474l.72.653c-.614-.24-1.33-.25-2.064-.017-1.55.49-2.76 2.002-2.88 3.596-.03.398.006.78.108 1.134.05.174.116.34.196.498l-.727-.659a2.482 2.482 0 01-.764-1.374z"
          fill="#121F3A"
        />
        <Path
          d="M39.648 13.343l1.406 1.273a5.559 5.559 0 00-1.598-2.58l-1.405-1.272a5.557 5.557 0 011.597 2.58z"
          fill="#75FAD4"
        />
        <Path
          d="M41.136 14.601l-.002-.007a5.672 5.672 0 00-1.622-2.62l-1.406-1.272a.085.085 0 10-.113.127h.002a5.496 5.496 0 011.57 2.54.083.083 0 00.025.04l1.406 1.272a.085.085 0 00.14-.08zm-2.143-2.868l.406.368c.662.6 1.168 1.37 1.476 2.24l-1.153-1.043a5.845 5.845 0 00-.729-1.565z"
          fill="#121F3A"
        />
        <Path
          d="M28.943 26.337a.319.319 0 01-.104-.062l-1.405-1.273c.03.027.063.048.103.062l1.924.693 1.406 1.272-1.924-.692z"
          fill="#75FAD4"
        />
        <Path
          d="M30.95 27.013a.082.082 0 00-.026-.046l-1.406-1.273a.091.091 0 00-.028-.017l-1.924-.692a.227.227 0 01-.076-.046.084.084 0 00-.12.008.086.086 0 00.007.12l1.406 1.272a.404.404 0 00.132.079l1.924.692a.085.085 0 00.111-.097zm-1.533-1.181l1.074.972-1.52-.547a.227.227 0 01-.075-.045l-1.04-.942 1.562.562z"
          fill="#121F3A"
        />
        <Path
          d="M29.981 25.544l1.406 1.273 1.1-1.671-1.406-1.273-1.1 1.671z"
          fill="#75FAD4"
        />
        <Path
          d="M32.57 25.128a.087.087 0 00-.026-.046l-1.406-1.273a.084.084 0 00-.12.006l-.007.01-1.1 1.672a.085.085 0 00.014.11l1.405 1.273a.084.084 0 00.12-.006l.007-.01 1.1-1.672a.086.086 0 00.013-.064zm-1.472-1.126l1.277 1.158-1.005 1.527-1.278-1.157 1.006-1.528z"
          fill="#121F3A"
        />
        <Path
          d="M29.46 25.757l1.406 1.272c.177.063.399-.026.52-.211l-1.405-1.273c-.122.186-.344.275-.52.212z"
          fill="#75FAD4"
        />
        <Path
          d="M31.47 26.8a.086.086 0 00-.026-.046L30.04 25.48a.084.084 0 00-.128.017c-.099.152-.28.229-.42.178a.085.085 0 00-.11.052.086.086 0 00.024.093l1.406 1.272a.092.092 0 00.028.017c.216.077.476-.026.62-.245a.087.087 0 00.011-.064zm-1.476-1.13l1.279 1.158c-.1.108-.243.16-.361.126l-1.22-1.104a.59.59 0 00.302-.18z"
          fill="#121F3A"
        />
        <Path
          d="M31.082 23.873l1.406 1.272a6.89 6.89 0 001.902-.15 8.049 8.049 0 001.891-.67l-1.405-1.272c-.6.299-1.234.527-1.891.67a6.905 6.905 0 01-1.902.15"
          fill="#75FAD4"
        />
        <Path
          d="M36.363 24.31a.082.082 0 00-.026-.047l-1.406-1.272a.085.085 0 00-.095-.014 7.984 7.984 0 01-1.87.663 6.852 6.852 0 01-1.88.148.085.085 0 00-.09.08.087.087 0 00.028.069l1.406 1.272c.014.013.032.02.05.022.631.04 1.28-.011 1.927-.152a8.164 8.164 0 001.91-.676.085.085 0 00.045-.094h.001zm-1.503-1.154l1.27 1.149a7.958 7.958 0 01-1.759.607 6.855 6.855 0 01-1.85.15l-1.207-1.093a7.07 7.07 0 001.688-.162 8.127 8.127 0 001.858-.65z"
          fill="#121F3A"
        />
        <Path
          d="M41.85 15.763l-.05-2.204a.374.374 0 00-.014-.1.322.322 0 00-.093-.15L43.1 14.58c.043.04.075.09.092.15a.38.38 0 01.015.1l.049 2.205-1.406-1.273z"
          fill="#75FAD4"
        />
        <Path
          d="M43.282 14.744a.41.41 0 00-.126-.225l-1.406-1.273a.084.084 0 00-.12.008.086.086 0 00.007.119c.032.03.055.068.067.11a.27.27 0 01.01.077l.05 2.206c0 .024.01.046.028.062l1.406 1.272a.085.085 0 00.142-.065l-.05-2.205a.465.465 0 00-.009-.087zm-1.396-1.145l1.157 1.048a.235.235 0 01.068.11c.006.024.01.05.01.077l.045 2.008-1.232-1.115-.048-2.127z"
          fill="#121F3A"
        />
        <Path
          d="M39.727 16.902l1.405 1.273 1.787-.658-1.406-1.273-1.786.659z"
          fill="#75FAD4"
        />
        <Path
          d="M43.001 17.5a.082.082 0 00-.026-.047l-1.406-1.273a.085.085 0 00-.086-.017l-1.787.658a.086.086 0 00-.05.11.08.08 0 00.023.034l1.406 1.273a.085.085 0 00.086.017l1.786-.658a.085.085 0 00.054-.098zm-1.507-1.159l1.262 1.144-1.606.592-1.263-1.143 1.607-.593z"
          fill="#121F3A"
        />
        <Path
          d="M41.512 16.243l1.405 1.273a.52.52 0 00.338-.48l-1.405-1.272a.521.521 0 01-.338.479z"
          fill="#75FAD4"
        />
        <Path
          d="M43.34 17.019a.082.082 0 00-.027-.047L41.908 15.7a.085.085 0 00-.142.065.436.436 0 01-.282.397.085.085 0 00-.028.144l1.406 1.272a.084.084 0 00.086.017.605.605 0 00.392-.576zm-1.428-1.086l1.26 1.14a.442.442 0 01-.237.343l-1.273-1.153a.619.619 0 00.25-.33z"
          fill="#121F3A"
        />
        <Path
          d="M37.9 20.612l1.406 1.273c.885-1.089 1.53-2.367 1.826-3.71l-1.406-1.273c-.297 1.343-.94 2.622-1.826 3.71z"
          fill="#75FAD4"
        />
        <Path
          d="M41.214 18.158a.082.082 0 00-.026-.047l-1.406-1.273a.085.085 0 00-.14.045c-.288 1.302-.913 2.573-1.808 3.674a.086.086 0 00.009.118l1.405 1.273a.085.085 0 00.12-.007l.003-.003c.912-1.122 1.549-2.417 1.842-3.745a.089.089 0 000-.036h.001zm-1.438-1.096l1.261 1.142c-.286 1.258-.887 2.485-1.742 3.557l-1.279-1.158c.853-1.068 1.459-2.287 1.76-3.54v-.001z"
          fill="#121F3A"
        />
        <Path
          d="M36.047 24.246l1.406 1.273c.131.12.345.11.512-.026l-1.405-1.272c-.167.135-.381.145-.513.025z"
          fill="#75FAD4"
        />
        <Path
          d="M38.05 25.478a.082.082 0 00-.027-.047l-1.406-1.272a.084.084 0 00-.11-.003c-.133.107-.302.12-.402.028a.085.085 0 00-.12.006.086.086 0 00.006.121l1.406 1.273c.163.148.425.138.622-.023a.084.084 0 00.03-.083zm-1.495-1.147l1.272 1.152c-.114.054-.237.046-.317-.026l-1.157-1.048a.551.551 0 00.202-.078z"
          fill="#121F3A"
        />
        <Path
          d="M38.618 22.213l1.406 1.273-.718-1.602-1.406-1.273.718 1.602z"
          fill="#75FAD4"
        />
        <Path
          d="M40.106 23.47a.071.071 0 00-.006-.018l-.718-1.602a.087.087 0 00-.02-.028l-1.406-1.273a.085.085 0 00-.134.099l.718 1.601c.005.011.013.021.021.029l1.406 1.273a.085.085 0 00.14-.08zm-.87-1.533l.544 1.215-1.092-.989-.545-1.215 1.093.989z"
          fill="#121F3A"
        />
        <Path
          d="M36.56 24.223l1.406 1.272 1.876-1.513-1.405-1.273-1.877 1.514z"
          fill="#75FAD4"
        />
        <Path
          d="M39.926 23.964a.082.082 0 00-.026-.046l-1.406-1.273a.084.084 0 00-.11-.003l-1.876 1.514a.086.086 0 00-.013.12l.01.01 1.405 1.273c.031.027.077.03.11.003l1.876-1.514a.087.087 0 00.03-.084zm-1.49-1.144l1.277 1.157-1.742 1.405-1.278-1.156 1.743-1.406z"
          fill="#121F3A"
        />
        <Path
          d="M38.438 22.708l1.405 1.273c.157-.127.228-.33.18-.495l-1.405-1.273c.048.165-.023.369-.18.495z"
          fill="#75FAD4"
        />
        <Path
          d="M40.114 23.498a.326.326 0 00-.008-.035.086.086 0 00-.025-.04l-1.406-1.272a.085.085 0 00-.138.087c.038.136-.023.302-.151.404a.085.085 0 00-.014.12c.003.004.006.008.01.01l1.406 1.273c.03.028.077.03.11.004a.582.582 0 00.217-.551zM38.71 22.41l1.239 1.122a.395.395 0 01-.106.333l-1.28-1.159a.607.607 0 00.147-.296z"
          fill="#121F3A"
        />
        <Path
          d="M36.035 24.236c.131.132.354.126.525-.014l1.877-1.513c.157-.127.228-.33.18-.495l-.717-1.602c.884-1.089 1.529-2.367 1.825-3.71l1.787-.658a.52.52 0 00.338-.48l-.05-2.204a.347.347 0 00-.014-.1.32.32 0 00-.34-.232l-1.8.117c-.352-1.202-1.045-2.193-1.97-2.89l.627-1.842a.427.427 0 00.01-.252.317.317 0 00-.198-.215l-1.924-.693c-.177-.062-.399.028-.52.212l-1.1 1.671a6.885 6.885 0 00-1.902.15c-.657.143-1.29.37-1.89.67l-1.162-1.182c-.131-.131-.353-.125-.525.014l-1.877 1.514c-.157.126-.228.33-.18.495l.718 1.601c-.885 1.089-1.529 2.368-1.826 3.71l-1.787.659a.522.522 0 00-.337.48l.049 2.204c0 .034.005.067.014.099a.32.32 0 00.34.232l1.8-.116c.354 1.203 1.046 2.192 1.97 2.89l-.627 1.842a.428.428 0 00-.01.252c.029.1.098.178.198.215l1.924.692c.176.063.398-.026.52-.212l1.1-1.67a6.886 6.886 0 001.902-.15 8.049 8.049 0 001.89-.67l1.162 1.182v-.001zm.012-7.993c-.116 1.551-1.311 3.043-2.821 3.52-1.65.523-3.105-.26-3.515-1.69a3.14 3.14 0 01-.105-1.105c.116-1.551 1.311-3.043 2.821-3.52 1.65-.524 3.106.258 3.516 1.689.097.335.135.707.105 1.106"
          fill="#fff"
        />
        <Path
          d="M41.877 13.47a.406.406 0 00-.436-.328l-1.732.112a5.6 5.6 0 00-1.932-2.83l.607-1.784a.51.51 0 00.01-.303.404.404 0 00-.249-.272l-1.924-.692c-.215-.076-.475.026-.62.245l-1.073 1.63a7.029 7.029 0 00-1.877.155 8.115 8.115 0 00-1.853.648l-1.12-1.137c-.163-.164-.431-.16-.639.007l-1.876 1.514c-.18.144-.267.384-.21.585a.062.062 0 00.005.011l.697 1.554c-.884 1.1-1.505 2.363-1.8 3.658l-1.743.643a.605.605 0 00-.393.562l.049 2.203a.46.46 0 00.017.122.407.407 0 00.427.294l1.732-.113c.353 1.15 1.02 2.126 1.933 2.832l-.607 1.783a.51.51 0 00-.011.303.404.404 0 00.25.272l1.924.693c.216.076.476-.027.619-.246l1.073-1.63a7.027 7.027 0 001.877-.155 8.118 8.118 0 001.855-.649l1.118 1.138c.163.164.431.16.639-.007l1.876-1.513c.18-.144.267-.384.21-.585a.062.062 0 00-.005-.011l-.697-1.554c.884-1.1 1.505-2.363 1.8-3.659l1.743-.642a.604.604 0 00.394-.561l-.05-2.205a.467.467 0 00-.009-.087zm-4.284-2.998c.004.02.016.04.033.052.929.7 1.6 1.683 1.94 2.844a.086.086 0 00.087.062l1.799-.117c.123-.008.22.058.253.17.007.025.01.05.01.078l.05 2.205a.436.436 0 01-.282.398l-1.787.658a.087.087 0 00-.054.062c-.288 1.302-.913 2.573-1.809 3.674a.086.086 0 00-.011.09l.715 1.595c.036.135-.027.298-.154.4l-1.877 1.513c-.138.112-.311.121-.411.02l-1.161-1.181a.085.085 0 00-.098-.017 7.98 7.98 0 01-1.871.663 6.844 6.844 0 01-1.88.148.085.085 0 00-.076.038l-1.1 1.671c-.099.153-.28.23-.42.18l-1.924-.693a.23.23 0 01-.144-.158.347.347 0 01.008-.202l.628-1.84a.085.085 0 00-.03-.096c-.927-.7-1.598-1.684-1.94-2.847a.086.086 0 00-.087-.06l-1.8.116c-.123.007-.22-.058-.253-.17a.278.278 0 01-.01-.077l-.05-2.204a.437.437 0 01.283-.4l1.787-.658a.087.087 0 00.053-.062c.289-1.302.914-2.573 1.809-3.674a.086.086 0 00.011-.09l-.715-1.595c-.036-.135.027-.298.153-.4l1.877-1.513c.139-.112.312-.121.413-.02l1.162 1.181a.085.085 0 00.098.017 7.985 7.985 0 011.869-.662 6.851 6.851 0 011.88-.149c.03.002.058-.012.075-.038l1.1-1.67c.1-.152.281-.23.42-.18l1.925.693a.23.23 0 01.144.157.346.346 0 01-.009.202l-.626 1.843a.087.087 0 00-.003.044zm-1.513 4.87a3.245 3.245 0 00-.055-.23 2.597 2.597 0 00-1.257-1.589c-.682-.369-1.522-.425-2.365-.158-1.55.49-2.761 2.002-2.88 3.596-.03.399.006.78.108 1.135a2.597 2.597 0 001.258 1.59c.682.37 1.522.425 2.365.159 1.55-.49 2.76-2.002 2.88-3.596.023-.315.005-.62-.052-.908h-.002zm-6.34 2.49a3.151 3.151 0 01-.049-.858c.115-1.527 1.276-2.976 2.762-3.445.8-.254 1.593-.202 2.234.146.571.31.988.837 1.174 1.485.096.335.13.697.102 1.076-.115 1.527-1.276 2.976-2.763 3.445-.798.253-1.591.202-2.233-.146a2.428 2.428 0 01-1.174-1.487 2.683 2.683 0 01-.053-.215z"
          fill="#121F3A"
        />
      </G>
      <Defs>
        <LinearGradient
          id="paint0_linear_5819_5190"
          x1={55.8633}
          y1={125.779}
          x2={104.816}
          y2={-3.19573}
          gradientUnits="userSpaceOnUse"
        >
          <Stop offset={0.49} stopColor="#286588" />
          <Stop offset={1} stopColor="#121F3A" />
        </LinearGradient>
      </Defs>
    </Svg>
  )
}

const NoData = () => {
  return (
    <Vertical className={"justify-center items-center text-center gap-3"}>
      <H5 color={"primary"} className={"text-center"}>
        Hang tight while {"\n"}we analyze your property!
      </H5>
      <Small color={"primary"} className={"text-center"}>
        It may take a few minutes to give you the most accurate terms.
      </Small>
      <HangTightClipart />
    </Vertical>
  )
}

export const PropertyDetails = () => {
  const { loanApplication } = useLoanContext()
  const [emptyAtFirst] = useState(
    // This didn't work, so need to try something else..
    // !loanApplication.purchasePrice && !loanApplication.afterRepairValue
    false
  )
  const [profit, setProfit] = useState(0)

  function HeaderValue() {
    if (!loanApplication.id) {
      return ""
    }

    if (!loanApplication.afterRepairValue || !loanApplication.purchasePrice) {
      if (emptyAtFirst) {
        return ""
      }
      return <BFText color={"error"}>Missing Info</BFText>
    }

    if (profit > 0) {
      return `Profit: ${formatNumber(profit, {
        prefix: "$",
        delimiter: ",",
        separator: ".",
      })}`
    }

    return (
      <BFText color={"error"}>
        {"Loss: " +
          formatNumber(Math.abs(profit), {
            delimiter: ",",
            separator: ".",
            prefix: "-$",
          })}
      </BFText>
    )
  }

  return (
    <AccordionItem value={"property-details"}>
      <AccordionHeader
        testId={"property-details-header"}
        text={"Property Details"}
        value={<HeaderValue />}
      />
      <AccordionContent>
        <Vertical className={"gap-2"}>
          <Body color={"primary"}>
            Review estimates and adjust to match your most accurate numbers.
          </Body>
          <Tiny color={"primary"}>
            You will be able to update this information later.
          </Tiny>
          {emptyAtFirst && (
            <Horizontal
              className={"bg-calm-blue p-3 rounded-md gap-3 items-center"}
            >
              <WarningCircle color={"white"} size={24} />
              <Vertical>
                <H5 color={"white"}>No estimates found for this property</H5>
                <Small color={"white"}>
                  Enter the details manually to proceed
                </Small>
              </Vertical>
            </Horizontal>
          )}
          <Container className={"p-5 min-h-72 items-center justify-center"}>
            {loanApplication?.id ? (
              <PropertyInfoSummary
                showErrors={true}
                onProfitChange={(profit) => {
                  setProfit(profit)
                }}
              />
            ) : (
              <NoData />
            )}
          </Container>
          <NegativeROIWarning show={profit < 0} />
        </Vertical>
      </AccordionContent>
    </AccordionItem>
  )
}
